import { useLingui } from '@lingui/react/macro'
import { useEffect, useState } from 'react'
import useSWR from 'swr'

import { useWorkOrder } from './useWorkOrder'
import { buildWorkOrderPdf } from './workOrderPdf'

export function useWorkOrderPdf(id: string) {
  const record = useWorkOrder(id)
  const { i18n } = useLingui()
  const { entry } = record
  const generated = useSWR(
    entry
      ? ['cmms-pdf-v6', entry.id, entry.data.source.version, i18n.locale]
      : null,
    () => (entry ? buildWorkOrderPdf(entry) : undefined),
    { revalidateOnFocus: false }
  )
  const [source, setSource] = useState<{ blob: Blob; url: string }>()
  const blob = generated.data?.blob
  useEffect(() => {
    if (!blob) return
    const url = URL.createObjectURL(blob)
    setSource({ blob, url })
    return () => URL.revokeObjectURL(url)
  }, [blob])
  return {
    ...record,
    retry: () => Promise.all([record.retry(), generated.mutate()]),
    pdf: generated.data,
    pdfUrl: source?.blob === blob ? source?.url : undefined,
    isLoading: record.isLoading || generated.isLoading,
    error: record.error || generated.error,
  }
}
